import PublicImage from './Public';
import LocalImage from './Local';

export {
  PublicImage,
  LocalImage,
};
